module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgments"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1"
    }
  }, [_vm._v("Mysterious Deaths")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter2"
    }
  }, [_vm._v("A Dream Halted")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Family in Flight")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outsiders in the Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boy-Crazy")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grave Suspicions")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Investigation Begins")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Investigation Stalls")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Catch a Killer")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tabloid Celebrity")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Trial Begins")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Defense Gathers Steam")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Closing and Verdict")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asyla")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Legend Ripples Outward")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Appendices",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendices")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a3ddcc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0